import { render, staticRenderFns } from "./ProjectTablePlan.vue?vue&type=template&id=667babdf"
import script from "./ProjectTablePlan.vue?vue&type=script&lang=js"
export * from "./ProjectTablePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports